@if (count > 0) {
  <span class="badge" [ngClass]="className">
    {{ count }}
  </span>
}
